import React, { Component, Fragment } from "react";
import { Container, Draggable } from "react-smooth-dnd";
import cloneDeep from "lodash.clonedeep";
import * as actionTypes from "../../../store/Actions/actions";
import "./Form.scss";
import ColorPicker from "../../Tool/ColorPicker/ColorPicker";
import Counter from "../../Tool/Counter/Counter";
import InputFields from "../../../assets/images/FormFields/inputText.svg";
import Textarea from "../../../assets/images/FormFields/textarea.svg";
import Dropdown from "../../../assets/images/FormFields/dropdown.svg";
import Heading from "../../../assets/images/FormFields/heading.svg";
import SubHeading from "../../../assets/images/FormFields/subheading.svg";
import Radio from "../../../assets/images/FormFields/radio.svg";
import Checkbox from "../../../assets/images/FormFields/checkbox.svg";
import DeleteOption from "../../../assets/images/closeUpload.svg";
import DeleteEmail from "../../../assets/images/closeCross.svg";
import Popup from "../../Modal/Popup";
import { connect } from "react-redux";
import FormFieldsModal from "./InputModal";
import * as UTILS from "../../../utils/Utils";
import UnitSelector from "../../Tool/UnitSelector/UnitSelector";
import { Alert } from "reactstrap";
import { message } from 'antd';
import { UserContext } from "../../../context/userContext.jsx";

const ALLOWED_USER_ID = "bdf1a48ea16bbbe2cf42d6ee26fdf544";

class Form extends Component {
  static contextType = UserContext;

  constructor(props) {
    super(props);
    this.state = {
      id: null,
      editFields: false,
      editIndex: null,
      newLabel: null,
      newPlaceholder: null,
      required: null,
      inputLabel: null,
      placeholder: null,
      addFields: false,
      optionVal: "",
      manage: false,
      FormObj: this.props.FormObj,
      formFields: this.props.formArray,
      Layout: this.props.Layout,
      radioLabel: "",
      showRadioLabel: true,
      radio: true,
      fonts: [],
      normalText: false,
      normalBg: false,
      normalBorder: false,
      hoverText: false,
      hoverBg: false,
      hoverBorder: false,
      formBorder: false,
      formBg: false,
      formColor: false,
      validEmailList: false,
      emailList: "",
      email:
        this.props.email === null || this.props.email === undefined ? "" : "",
      identifier: this.props.FormObj.identifier,
      identifierError: "",
      submitBtnHover: false,
      selectedRadioValues: {}
    };
    this.handleRadioChange = this.handleRadioChange.bind(this);
  }
  componentDidMount = () => {
    //
    this.setState({
      ...this.state,
      fonts: this.props.googleFonts,
      formFields: this.props.formArray,
      email: this.props.email,
    });
  };
  componentDidUpdate(prevProps) {

    if (prevProps != this.props) {
      // Check if it's a new user, you can also use some unique property, like the ID  (this.props.user.id !== prevProps.user.id)
      //
      this.setState({
        formFields: this.props.formArray,
        identifier: this.props.FormObj.identifier,
        email: this.props.email,
      });
    }
  }
  toggleHover = (e) => {
    e.preventDefault();
    this.setState({
      submitBtnHover: !this.state.submitBtnHover,
    });
  };
  setIdForEditHandler = (editID) => {
    this.setState({
      id: editID,
    });
  };
  editFields = () => {
    this.setState({
      editFields: !this.state.editFields,
    });
  };
  editThis = (ind) => {
    this.setState({
      editIndex: ind,
    });
  };
  requiredChange = (e, index, ID) => {
    const layout = cloneDeep(this.props.layout);
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.fields[index].required = !item.fields[index].required;
      },
      (colItem) => {
        colItem.fields[index].required = !colItem.fields[index].required;
      },
      (colItemNested) => {
        colItemNested.fields[index].required =
          !colItemNested.fields[index].required;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  showRadioButtonGroupLabel = (e, index) => {
    const checked = e.target.checked;

    let layout = cloneDeep(this.props.layout);
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.fields[index].show_label = checked;
      },
      (colItem) => {
        colItem.fields[index].show_label = checked;
      },
      (colItemNested) => {
        colItemNested.fields[index].show_label = checked;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  handleRadioChange(groupIndex, value) {
    this.setState(prevState => ({
      selectedRadioValues: {
        ...prevState.selectedRadioValues,
        [groupIndex]: value
      }
    }));
  }
  inputLabelChange = (e, index, ID) => {
    let layout = cloneDeep(this.props.layout);
    const newVal = e.target.value;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.fields[index].label = newVal;
      },
      (colItem) => {
        colItem.fields[index].label = newVal;
      },
      (colItemNested) => {
        colItemNested.fields[index].label = newVal;
      }
    );

    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  headingLabelChange = (e, index, ID) => {
    let layout = cloneDeep(this.props.layout);
    const newLayout = UTILS.UpdateLayout(
      layout,
      ID,
      (item) => {
        item.fields[index].content = e.target.value;
      },
      (colItem) => {
        colItem.fields[index].content = e.target.value;
      },
      (colItemNested) => {
        colItemNested.fields[index].content = e.target.value;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  subHeadingLabelChange = (e, index, ID) => {
    let layout = cloneDeep(this.props.layout);
    const newLayout = UTILS.UpdateLayout(
      layout,
      ID,
      (item) => {
        item.fields[index].content = e.target.value;
      },
      (colItem) => {
        colItem.fields[index].content = e.target.value;
      },
      (colItemNested) => {
        colItemNested.fields[index].content = e.target.value;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  inputPlaceholderChange = (e, index, ID) => {
    let layout = cloneDeep(this.props.layout);
    const newLayout = UTILS.UpdateLayout(
      layout,
      ID,
      (item) => {
        item.fields[index].placeholder = e.target.value;
      },
      (colItem) => {
        colItem.fields[index].placeholder = e.target.value;
      },
      (colItemNested) => {
        colItemNested.fields[index].placeholder = e.target.value;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  deleteInput = (index, ID) => {
    let layout = cloneDeep(this.props.layout);
    const newLayout = UTILS.UpdateLayout(
      layout,
      ID,
      (item) => {
        item.fields.splice(index, 1);
      },
      (colItem) => {
        colItem.fields.splice(index, 1);
      },
      (colItemNested) => {
        colItemNested.fields.splice(index, 1);
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  addNewField = (id, field) => {
    const layout = cloneDeep(this.props.layout);
    const newFields = this.state.formFields.splice(
      this.state.formFields.length + 1,
      0,
      field
    );
    const newLayout = UTILS.UpdateLayout(
      layout,
      id,
      (item) => {
        item.fields.splice(item.fields.length - 1, 0, field);
      },
      (colItem) => {
        colItem.fields.splice(colItem.fields.length - 1, 0, field);
      },
      (colItemNested) => {
        colItemNested.fields.splice(colItemNested.fields.length - 1, 0, field);
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  addOptions = (ind, id, option) => {
    if (this.state.optionVal.length > 0) {
      const layout = cloneDeep(this.props.layout);
      const newLayout = UTILS.UpdateLayout(
        layout,
        id,
        (item) => {
          item.fields[ind].options.splice(
            item.fields[ind].options + 1,
            0,
            option
          );
        },
        (colItem) => {
          colItem.fields[ind].options.splice(
            colItem.fields[ind].options + 1,
            0,
            option
          );
        },
        (colItemNested) => {
          colItemNested.fields[ind].options.splice(
            colItemNested.fields[ind].options + 1,
            0,
            option
          );
        }
      );
      this.props.layoutArray(this.props.layoutTitle, newLayout);

      this.setState({
        optionVal: "",
      });
    }
  };
  deleteOption = (ind, id, itemInd) => {
    const layout = cloneDeep(this.props.layout);
    layout.map((item) => {
      if (item.id == id) {
        item.fields[ind].options.splice(itemInd, 1);
        return item;
      }
      if (item.data == "Row") {
        Object.keys(item.columns).map((col, colIndex) => {
          return item.columns[col].map((colItem) => {
            if (colItem.id == id) {
              colItem.fields[ind].options.splice(itemInd, 1);
              return colItem;
            }
            return colItem;
          });
        });
      }
      return item;
    });
    this.props.layoutArray(this.props.layoutTitle, layout);
  };

  validateEmailList = (raw) => {
    var emails = raw.split(",");

    var valid = true;
    var regex =
      /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    for (var i = 0; i < emails.length; i++) {
      if (emails[i] === "" || !regex.test(emails[i].replace(/\s/g, ""))) {
        valid = false;
      }
    }
    return valid;
  };
  removeValue = (list, value) => {
    return list.replace(new RegExp(",?" + value + ",?"), function (match) {
      var first_comma = match.charAt(0) === ",",
        second_comma;

      if (
        first_comma &&
        (second_comma = match.charAt(match.length - 1) === ",")
      ) {
        return ",";
      }
      return "";
    });
  };
  deleteEmail = (email) => {
    const updatedList = this.props.email.replace(
      new RegExp(",?" + email + ",?"),
      function (match) {
        var first_comma = match.charAt(0) === ",",
          second_comma;

        if (
          first_comma &&
          (second_comma = match.charAt(match.length - 1) === ",")
        ) {
          return ",";
        }
        return "";
      }
    );
    let layout = this.props.layout;
    this.props.layoutArray(
      this.props.layoutTitle,
      layout.map((item) => {
        if (item.id == this.props.ID) {
          item.email = updatedList;
          return item;
        }
        if (item.data == "Row" || item.data == "Accordion") {
          Object.keys(item.columns).map((col, colIndex) => {
            return item.columns[col].map((colItem) => {
              if (colItem.id == this.props.ID) {
                colItem.email = updatedList;
                return colItem;
              }
              if (colItem.data == "Row" || colItem.data == "Accordion") {
                Object.keys(colItem.columns).map((colI, colItemIndex) => {
                  return colItem.columns[colI].map((colNestItem) => {
                    if (colNestItem.id == this.props.ID) {
                      colNestItem.email = updatedList;
                      return colNestItem;
                    }
                  });
                });
              }
              return colItem;
            });
          });
        }
        return item;
      })
    );
  };
  formEmailAddress = (e) => {
    const layout = cloneDeep(this.props.layout);
    const emailList = this.state.emailList;
    //

    if (this.validateEmailList(emailList) == false) {
      this.setState(
        {
          ...this.state,
          emailError: "invalidEmail",
        },
        this.dismissErrorAlert
      );
      return;
    } else if (this.state.email.includes(this.state.emailList)) {
      this.setState(
        {
          ...this.state,
          emailError: "alreadyExists",
        },
        this.dismissErrorAlert
      );
    } else if (this.validateEmailList(emailList) && emailList !== "") {
      this.setState({ validEmailList: false });
      let updatedEmails =
        this.props.email == null ||
          this.props.email == "," ||
          this.props.email.length < 1 ||
          this.props.email == ""
          ? emailList
          : this.props.email + "," + emailList;
      this.props.layoutArray(
        this.props.layoutTitle,
        layout.map((item) => {
          if (item.id == this.props.ID) {
            item.email = updatedEmails;
            return item;
          }
          if (item.data == "Row" || item.data == "Accordion") {
            Object.keys(item.columns).map((col, colIndex) => {
              return item.columns[col].map((colItem) => {
                if (colItem.id == this.props.ID) {
                  colItem.email = updatedEmails;
                  return colItem;
                }
                if (colItem.data == "Row" || colItem.data == "Accordion") {
                  Object.keys(colItem.columns).map((colI, colItemIndex) => {
                    return colItem.columns[colI].map((colNestItem) => {
                      if (colNestItem.id == this.props.ID) {
                        colNestItem.email = updatedEmails;
                        return colNestItem;
                      }
                    });
                  });
                }
                return colItem;
              });
            });
          }
          return item;
        })
      );
      this.setState({
        emailList: "",
      });
    } else {
      this.setState({
        validEmailList: true,
      });
    }
  };
  handleKeyDown = (e) => {
    if (e.key === "Enter") {
      this.formEmailAddress();
    }
  };
  sortingFormFields = (e) => {
    const layout = JSON.parse(JSON.stringify(this.props.layout));
    const SortedFields = UTILS.applyDrag(this.state.formFields, e);
    this.setState(
      {
        formFields: SortedFields,
      },
      () => {
        const newLayout = UTILS.UpdateLayout(
          layout,
          this.props.ID,
          (item) => {
            item.fields = SortedFields;
          },
          (colItem) => {
            colItem.fields = SortedFields;
          },
          (colItemNested) => {
            colItemNested.fields = SortedFields;
          }
        );
        this.props.layoutArray(this.props.layoutTitle, newLayout);
      }
    );
  };
  sortSelectOptions = (e, mainIndex) => {
    const layout = JSON.parse(JSON.stringify(this.props.layout));
    const selectField = this.state.formFields.filter((item, index) => {
      return index == mainIndex;
    });
    const sortedOptions = UTILS.applyDrag(selectField[0].options, e);
    const sortedFormFields = this.state.formFields.map((item, index) => {
      if (index == mainIndex) {
        item.options = sortedOptions;
        return item;
      }
      return item;
    });

    this.setState(
      {
        formFields: sortedFormFields,
      },
      () => {
        const newLayout = UTILS.UpdateLayout(
          layout,
          this.props.ID,
          (item) => {
            item.fields = sortedFormFields;
          },
          (colItem) => {
            colItem.fields = sortedFormFields;
          },
          (colItemNested) => {
            colItemNested.fields = sortedFormFields;
          }
        );
        this.props.layoutArray(this.props.layoutTitle, newLayout);
      }
    );
  };
  sortingRadio = (e, mainIndex) => {
    const layout = JSON.parse(JSON.stringify(this.props.layout));
    const radioGroup = this.state.formFields.filter((item, index) => {
      return index == mainIndex;
    });
    const sortedRadio = UTILS.applyDrag(radioGroup[0].radioFields, e);
    const sortedFormFields = this.state.formFields.map((item, index) => {
      if (index == mainIndex) {
        item.radioFields = sortedRadio;
        return item;
      }
      return item;
    });

    this.setState(
      {
        formFields: sortedFormFields,
      },
      () => {
        const newLayout = UTILS.UpdateLayout(
          layout,
          this.props.ID,
          (item) => {
            item.fields = sortedFormFields;
          },
          (colItem) => {
            colItem.fields = sortedFormFields;
          },
          (colItemNested) => {
            colItemNested.fields = sortedFormFields;
          }
        );
        this.props.layoutArray(this.props.layoutTitle, newLayout);
      }
    );
  };
  newRadioLabel = (e, indexField) => {
    this.setState({
      radioLabel: e.target.value,
    });
  };
  deleteRadioButton = (radioIndex, deleteIndex) => {
    let formFields = cloneDeep(this.state.formFields);
    const layout = cloneDeep(this.props.layout);
    const newFormFields = formFields.map((item, index) => {
      if (radioIndex == index) {
        item.radioFields.splice(deleteIndex, 1);
        return item;
      }
      return item;
    });
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.fields = newFormFields;
      },
      (colItem) => {
        colItem.fields = newFormFields;
      },
      (colItemNested) => {
        colItemNested.fields = newFormFields;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  pushRadioButton = (indexField) => {
    let formFields = cloneDeep(this.state.formFields);
    const layout = cloneDeep(this.props.layout);
    const radioButton = this.state.radioLabel;
    const newFormFields = formFields.map((item, index) => {
      if (indexField == index) {
        item.radioFields.splice(item.radioFields.length + 1, 0, {
          data: "radio",
          type: "radio",
          label: radioButton,
        });
        return item;
      }
      return item;
    });
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.fields = newFormFields;
      },
      (colItem) => {
        colItem.fields = newFormFields;
      },
      (colItemNested) => {
        colItemNested.fields = newFormFields;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
    this.setState({
      radioLabel: "",
    });
  };
  selectButtonFont = (e, indexField) => {
    let formFields = cloneDeep(this.state.formFields);
    const layout = cloneDeep(this.props.layout);
    const selectedFont = e.target.value;
    const newFormFields = formFields.map((item, index) => {
      if (indexField == index) {
        item.style.fontFamily = selectedFont;
        return item;
      }
      return item;
    });
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.fields = newFormFields;
      },
      (colItem) => {
        colItem.fields = newFormFields;
      },
      (colItemNested) => {
        colItemNested.fields = newFormFields;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  selectButtonFontSize = (e, indexField) => {
    let formFields = cloneDeep(this.state.formFields);
    const layout = cloneDeep(this.props.layout);
    const selectedFontSize = e.target.value;

    const newFormFields = formFields.map((item, index) => {
      if (indexField == index) {
        item.style.fontSize = selectedFontSize !== "" ? selectedFontSize : "0";
        return item;
      }
      return item;
    });
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.fields = newFormFields;
      },
      (colItem) => {
        colItem.fields = newFormFields;
      },
      (colItemNested) => {
        colItemNested.fields = newFormFields;
      }
    );

    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  buttonAlign = (e, indexField) => {
    let formFields = cloneDeep(this.state.formFields);
    const layout = cloneDeep(this.props.layout);
    const selectedAlign = e.target.value;

    const newFormFields = formFields.map((item, index) => {
      if (indexField == index) {
        item.style.float = selectedAlign;
        return item;
      }
      return item;
    });
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.fields = newFormFields;
      },
      (colItem) => {
        colItem.fields = newFormFields;
      },
      (colItemNested) => {
        colItemNested.fields = newFormFields;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  counterChange = (e, property, indexField) => {
    let formFields = cloneDeep(this.state.formFields);
    const layout = cloneDeep(this.props.layout);
    const selectedValue =
      e.target.value !== "" && e.target.value !== "0" && e.target.value !== "00"
        ? e.target.value.replace(/\b0+/g, "")
        : "0";

    const newFormFields = formFields.map((item, index) => {
      if (indexField == index) {
        item.style[property] = selectedValue;
        return item;
      }
      return item;
    });
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.fields = newFormFields;
      },
      (colItem) => {
        colItem.fields = newFormFields;
      },
      (colItemNested) => {
        colItemNested.fields = newFormFields;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  counterPlus = (value, indexField, property) => {
    let formFields = cloneDeep(this.state.formFields);
    const layout = cloneDeep(this.props.layout);
    const selectedValue = value;
    const newFormFields = formFields.map((item, index) => {
      if (indexField == index) {
        item.style[property] = JSON.stringify(JSON.parse(selectedValue) + 1);
        return item;
      }
      return item;
    });
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.fields = newFormFields;
      },
      (colItem) => {
        colItem.fields = newFormFields;
      },
      (colItemNested) => {
        colItemNested.fields = newFormFields;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  counterMinus = (value, indexField, property) => {
    let formFields = cloneDeep(this.state.formFields);
    const layout = cloneDeep(this.props.layout);
    const selectedValue = value > 1 ? value : "1";

    const newFormFields = formFields.map((item, index) => {
      if (indexField == index) {
        item.style[property] = JSON.stringify(JSON.parse(selectedValue) - 1);
        return item;
      }
      return item;
    });
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.fields = newFormFields;
      },
      (colItem) => {
        colItem.fields = newFormFields;
      },
      (colItemNested) => {
        colItemNested.fields = newFormFields;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  changeColor = (colorCode, toUpdate, toUpdateNext, indexField) => {
    let formFields = cloneDeep(this.state.formFields);
    const layout = cloneDeep(this.props.layout);

    const selectedValue = colorCode.rgb;
    const keyToUpdate = toUpdate;
    const newFormFields = formFields.map((item, index) => {
      if (indexField == index) {
        item[keyToUpdate][toUpdateNext] = selectedValue;
        return item;
      }
      return item;
    });
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.fields = newFormFields;
      },
      (colItem) => {
        colItem.fields = newFormFields;
      },
      (colItemNested) => {
        colItemNested.fields = newFormFields;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  changeFormColor = (e, ID, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = e.rgb;
    const newLayout = UTILS.UpdateLayout(
      layout,
      ID,
      (item) => {
        item.style[property] = selectedValue;
      },
      (colItem) => {
        colItem.style[property] = selectedValue;
      },
      (colItemNested) => {
        colItemNested.style[property] = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  formCounterPlus = (value, ID, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = value;
    const newLayout = UTILS.UpdateLayout(
      layout,
      ID,
      (item) => {
        item.style[property] = JSON.stringify(JSON.parse(selectedValue) + 1);
      },
      (colItem) => {
        colItem.style[property] = JSON.stringify(JSON.parse(selectedValue) + 1);
      },
      (colItemNested) => {
        colItemNested.style[property] = JSON.stringify(
          JSON.parse(selectedValue) + 1
        );
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  formCounterChange = (e, ID, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue =
      e.target.value !== "" && e.target.value !== "0" && e.target.value !== "00"
        ? e.target.value.replace(/\b0+/g, "")
        : "0";
    const newLayout = UTILS.UpdateLayout(
      layout,
      ID,
      (item) => {
        item.style[property] = selectedValue;
      },
      (colItem) => {
        colItem.style[property] = selectedValue;
      },
      (colItemNested) => {
        colItemNested.style[property] = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  unitValueChange = (e, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = e.target.value;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style[property] = selectedValue;
      },
      (colItem) => {
        colItem.style[property] = selectedValue;
      },
      (colItemNested) => {
        colItemNested.style[property] = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  widthToggle = (e, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = e.target.checked == true ? "0" : "500";
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style[property] = selectedValue;
      },
      (colItem) => {
        colItem.style[property] = selectedValue;
      },
      (colItemNested) => {
        colItemNested.style[property] = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  formCounterMinus = (value, ID, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = value > 1 ? value : "1";
    const newLayout = UTILS.UpdateLayout(
      layout,
      ID,
      (item) => {
        item.style[property] = JSON.stringify(JSON.parse(selectedValue) - 1);
      },
      (colItem) => {
        colItem.style[property] = JSON.stringify(JSON.parse(selectedValue) - 1);
      },
      (colItemNested) => {
        colItemNested.style[property] = JSON.stringify(
          JSON.parse(selectedValue) - 1
        );
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };
  saveIdentifier = (e) => {
    const layout = cloneDeep(this.props.layout);
    var identifier = e.target.value;
    const validateFormIdResult = UTILS.validateFormId(identifier);

    if (validateFormIdResult == "invalidChars") {
      //
      this.setState(
        {
          ...this.state,
          identifierError: "invalidChars",
        },
        () => {
          this.dismissErrorAlert();
        }
      );
      return;
    } else if (validateFormIdResult == "tooLong") {
      this.setState(
        {
          ...this.state,
          identifierError: "tooLong",
        },
        () => {
          this.dismissErrorAlert();
        }
      );
      return;
    } else if (validateFormIdResult == "tooShort") {
      this.setState(
        {
          ...this.state,
          identifierError: "tooShort",
        },
        () => {
          setTimeout(this.dismissErrorAlert, 4000);
        }
      );
    } else if (validateFormIdResult == "validId") {
      this.setState({
        ...this.state,
        identifierError: "",
      });
      this.props.layoutArray(
        this.props.layoutTitle,
        layout.map((item) => {
          if (item.id == this.props.ID) {
            item.identifier = identifier;
            return item;
          }
          if (item.data == "Row" || item.data == "Accordion") {
            Object.keys(item.columns).map((col, colIndex) => {
              return item.columns[col].map((colItem) => {
                if (colItem.id == this.props.ID) {
                  colItem.identifier = identifier;
                  return colItem;
                }
                if (colItem.data == "Row" || colItem.data == "Accordion") {
                  Object.keys(colItem.columns).map((colI, colItemIndex) => {
                    return colItem.columns[colI].map((colNestItem) => {
                      if (colNestItem.id == this.props.ID) {
                        colNestItem.identifier = identifier;
                        return colNestItem;
                      }
                    });
                  });
                }
                return colItem;
              });
            });
          }
          return item;
        })
      );
      this.setState({
        identifier: "",
      });
    }
  };

  deleteIdentifier = () => {
    const layout = cloneDeep(this.props.layout);
    this.props.layoutArray(
      this.props.layoutTitle,
      layout.map((item) => {
        if (item.id == this.props.ID) {
          item.identifier = "";
          return item;
        }
        if (item.data == "Row" || item.data == "Accordion") {
          Object.keys(item.columns).map((col, colIndex) => {
            return item.columns[col].map((colItem) => {
              if (colItem.id == this.props.ID) {
                colItem.identifier = "";
                return colItem;
              }
              if (colItem.data == "Row" || colItem.data == "Accordion") {
                Object.keys(colItem.columns).map((colI, colItemIndex) => {
                  return colItem.columns[colI].map((colNestItem) => {
                    if (colNestItem.id == this.props.ID) {
                      colNestItem.identifier = "";
                      return colNestItem;
                    }
                  });
                });
              }
              return colItem;
            });
          });
        }
        return item;
      })
    );
  };

  handleKeyDownIdentifier = (e) => {
    if (e.key === "Enter") {
      this.saveIdentifier(e);
    }
  };

  handleSendConfirmationEmails = (event) => {
    const sendConfirmation = event.target.checked;
    const layout = cloneDeep(this.props.layout);

    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.sendConfirmation = sendConfirmation;
      },
      (colItem) => {
        colItem.sendConfirmation = sendConfirmation;
      },
      (colItemNested) => {
        colItemNested.sendConfirmation = sendConfirmation;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  buttonSetting = (e, property) => {
    const layout = cloneDeep(this.props.layout);
    const selectedValue = e.target.value;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.style[property] = selectedValue;
      },
      (colItem) => {
        colItem.style[property] = selectedValue;
      },
      (colItemNested) => {
        colItemNested.style[property] = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  addFormLabel = (event) => {
    /* signal to React not to nullify the event object */
    event.persist();

    const layout = cloneDeep(this.props.layout);
    const selectedValue = event.target.value;
    const newLayout = UTILS.UpdateLayout(
      layout,
      this.props.ID,
      (item) => {
        item.label = selectedValue;
      },
      (colItem) => {
        colItem.label = selectedValue;
      },
      (colItemNested) => {
        colItemNested.label = selectedValue;
      }
    );
    this.props.layoutArray(this.props.layoutTitle, newLayout);
  };

  dismissErrorAlert = () => {
    setTimeout(() => {
      this.setState({
        ...this.state,
        identifierError: "",
        emailError: "",
      });
    }, 4000);
  };

  render() {
    let buttonText;
    let buttonBg;
    let buttonBorder;

    const formConfig = {
      enabled: this.context?.userID === ALLOWED_USER_ID,
    };


    const radioGroupIndices = this.state.formFields
      .map((item, index) => item.type === "radioGroup" ? index : null)
      .filter(index => index !== null);
    const allRadioGroupsSelected = radioGroupIndices.length === 0 || radioGroupIndices.every(
      index => this.state.selectedRadioValues[index] && this.state.selectedRadioValues[index] !== ''
    );


    const formFields = (
      <Container
        onDragStart={() => {
          //  setTimeout(function(){debugger }, 2000);
        }}
        dragHandleSelector=".form-drag-handle"
        onDrop={this.sortingFormFields}
      >
        {this.state.formFields.map((item, index) => {
          if (
            item.type == "text" ||
            item.type == "email" ||
            item.type == "number"
          ) {
            return (
              <Draggable key={index}>
                <div
                  className={
                    "form-group " + (this.state.editFields ? "editingForm" : "")
                  }
                  key={index}
                >
                  {item.label ? (
                    <div>
                      {item.label} <sup>{item.required ? "*" : ""}</sup>
                    </div>
                  ) : null}
                  <input
                    className="form-control"
                    type={item.type}
                    placeholder={item.placeholder}
                    style={formConfig.enabled ? { fontFamily: "inherit" } : undefined}
                  />
                  {this.state.editFields && (
                    <div className="action">
                      <span
                        className={
                          "editField " +
                          (this.state.editIndex == index ? "active" : " ")
                        }
                        onClick={() => {
                          this.editThis(index);
                        }}
                      ></span>
                      <span
                        className="deleteField"
                        onClick={() => {
                          this.deleteInput(index, this.props.ID);
                        }}
                      ></span>
                      <span className="form-drag-handle">
                        <i className="fas fa-arrows-alt" />
                      </span>
                    </div>
                  )}
                  {this.state.editIndex == index && (
                    <Popup
                      width="500"
                      header="Input Text Settings"
                      //  parentID="formManage"
                      // save={this.pushBlockToCanvas}
                      // btnLabel="Select"
                      closePopup={() => {
                        this.setState({ editIndex: null });
                      }}
                      close={() => {
                        this.setState({ editIndex: null });
                      }}
                    >
                      <div className=" modalContentWrapper">
                        <div className="col-sm-12">
                          <div>Input Label</div>
                          <input
                            className="form-control"
                            defaultValue={item.label}
                            onChange={(e) => {
                              this.inputLabelChange(e, index, this.props.ID);
                            }}
                            type="text"
                          />
                        </div>
                        <div className="col-sm-12">
                          <div>Placeholder</div>
                          <input
                            className="form-control"
                            value={item.placeholder}
                            onChange={(e) => {
                              this.inputPlaceholderChange(
                                e,
                                index,
                                this.props.ID
                              );
                            }}
                            type="text"
                          />
                        </div>
                        <div className="col-sm-12 required">
                          <div>Required</div>
                          <div className="radiusToggle">
                            <input
                              key={Math.random()}
                              onChange={(event) => {
                                this.requiredChange(
                                  event,
                                  index,
                                  this.props.ID
                                );
                              }}
                              type="checkbox"
                              id="autoplay"
                              checked={item.required && "checked"}
                            />
                          </div>
                        </div>
                      </div>
                    </Popup>
                  )}
                </div>
              </Draggable>
            );
          }

          if (item.type == "heading") {
            return (
              <Draggable key={index}>
                <div
                  className={
                    "form-group heading " +
                    (this.state.editFields ? "editingForm" : "")
                  }
                >
                  <h2 key={index}>{item.content}</h2>
                  {this.state.editFields && (
                    <div className="action">
                      <span
                        className={
                          "editField " +
                          (this.state.editIndex == index ? "active" : " ")
                        }
                        onClick={() => {
                          this.editThis(index);
                        }}
                      ></span>
                      <span
                        className="deleteField"
                        onClick={() => {
                          this.deleteInput(index, this.props.ID);
                        }}
                      ></span>
                      <span className="form-drag-handle">
                        <i className="fas fa-arrows-alt" />
                      </span>
                    </div>
                  )}
                  {this.state.editIndex == index && (
                    <Popup
                      width="500"
                      header="Add Heading Text"
                      //  parentID="formManage"
                      // save={this.pushBlockToCanvas}
                      // btnLabel="Select"
                      closePopup={() => {
                        this.setState({ editIndex: null });
                      }}
                      close={() => {
                        this.setState({ editIndex: null });
                      }}
                    >
                      <div style={{ padding: "25px" }}>
                        <div>Heading text</div>
                        <input
                          className="form-control"
                          value={item.content}
                          onChange={(e) => {
                            this.headingLabelChange(e, index, this.props.ID);
                          }}
                          type="text"
                        />
                      </div>
                    </Popup>
                  )}
                </div>
              </Draggable>
            );
          }
          if (item.type == "subheading") {
            return (
              <Draggable key={index}>
                <div
                  className={
                    "form-group subheading " +
                    (this.state.editFields ? "editingForm" : "")
                  }
                  key={index}
                >
                  <p>{item.content}</p>
                  {this.state.editFields && (
                    <div className="action">
                      <span
                        className={
                          "editField " +
                          (this.state.editIndex == index ? "active" : " ")
                        }
                        onClick={() => {
                          this.editThis(index);
                        }}
                      ></span>
                      <span
                        className="deleteField"
                        onClick={() => {
                          this.deleteInput(index, this.props.ID);
                        }}
                      ></span>
                      <span className="form-drag-handle">
                        <i className="fas fa-arrows-alt" />
                      </span>
                    </div>
                  )}
                  {this.state.editIndex == index && (
                    <Popup
                      width="500"
                      header="Sub Heading Text"
                      //  parentID="formManage"
                      // save={this.pushBlockToCanvas}
                      // btnLabel="Select"
                      closePopup={() => {
                        this.setState({ editIndex: null });
                      }}
                      close={() => {
                        this.setState({ editIndex: null });
                      }}
                    >
                      <div style={{ padding: "25px" }}>
                        <div>Sub Heading Text</div>
                        <input
                          className="form-control"
                          value={item.content}
                          onChange={(e) => {
                            this.subHeadingLabelChange(e, index, this.props.ID);
                          }}
                          type="text"
                        />
                      </div>
                    </Popup>
                  )}
                </div>
              </Draggable>
            );
          }

          if (item.type == "textarea") {
            return (
              <Draggable key={index}>
                <div
                  className={
                    "form-group " + (this.state.editFields ? "editingForm" : "")
                  }
                  key={index}
                >
                  <div>
                    {item.label} <sup>{item.required ? "*" : ""}</sup>
                  </div>

                  <textarea
                    className="form-control"
                    placeholder={item.placeholder}
                    style={formConfig.enabled ? { fontFamily: "inherit" } : undefined}
                  />
                  {this.state.editFields && (
                    <div className="action">
                      <span
                        className={
                          "editField " +
                          (this.state.editIndex == index ? "active" : " ")
                        }
                        onClick={() => {
                          this.editThis(index);
                        }}
                      ></span>
                      <span
                        className="deleteField"
                        onClick={() => {
                          this.deleteInput(index, this.props.ID);
                        }}
                      ></span>
                      <span className="form-drag-handle">
                        <i className="fas fa-arrows-alt" />
                      </span>
                    </div>
                  )}
                  {this.state.editIndex == index && (
                    <Popup
                      width="500"
                      header="Add Text Area"
                      //  parentID="formManage"
                      // save={this.pushBlockToCanvas}
                      // btnLabel="Select"
                      closePopup={() => {
                        this.setState({ editIndex: null });
                      }}
                      close={() => {
                        this.setState({ editIndex: null });
                      }}
                    >
                      <div style={{ padding: "25px" }}>
                        <div className="col-sm-12">
                          <div>Input Label</div>
                          <input
                            className="form-control"
                            value={item.label}
                            onChange={(e) => {
                              this.inputLabelChange(e, index, this.props.ID);
                            }}
                            type="text"
                          />
                        </div>
                        <div className="col-sm-12">
                          <div>Placeholder</div>
                          <input
                            className="form-control"
                            value={item.placeholder}
                            onChange={(e) => {
                              this.inputPlaceholderChange(
                                e,
                                index,
                                this.props.ID
                              );
                            }}
                            type="text"
                          />
                        </div>
                        <div className="col-sm-12 required">
                          <div>Required</div>
                          <div className="radiusToggle">
                            <input
                              key={Math.random()}
                              onChange={(event) => {
                                this.requiredChange(
                                  event,
                                  index,
                                  this.props.ID
                                );
                              }}
                              type="checkbox"
                              id="autoplay"
                              checked={item.required && "checked"}
                            />
                          </div>
                        </div>
                      </div>
                    </Popup>
                  )}
                </div>
              </Draggable>
            );
          }
          if (item.type == "radioGroup") {
            return (
              <Draggable key={index}>
                <div
                  className={
                    "form-group radioGrouping " +
                    (this.state.editFields ? "editingForm" : "")
                  }
                >
                  {item.show_label ? (
                    <div className="bottom-0">
                      {item.label} <sup>{item.required ? "*" : ""}</sup>
                    </div>
                  ) : null}
                  {item.radioFields.map((field, i) => {
                    return (
                      <Fragment key={i}>
                        <div className="form-group" key={field + this.props.ID}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                            className="radio"
                          >
                            <input
                              type={field.type}
                              value={field.label}
                              name={"radio-" + index + this.props.ID}
                              id={"radio-" + index + i + this.props.ID}
                              onChange={(e) => this.handleRadioChange(index, e.target.value)}
                              checked={this.state.selectedRadioValues[index] === field.label}
                            />
                            <div
                              className="radio-label"
                              htmlFor={"radio-" + index + i + this.props.ID}
                            >
                              {field.label}
                            </div>
                          </div>
                        </div>
                      </Fragment>
                    );
                  })}
                  {this.state.editFields && (
                    <div className="action">
                      <span
                        className={
                          "editField " +
                          (this.state.editIndex == index ? "active" : " ")
                        }
                        onClick={() => {
                          this.editThis(index);
                        }}
                      ></span>
                      <span
                        className="deleteField"
                        onClick={() => {
                          this.deleteInput(index, this.props.ID);
                        }}
                      ></span>
                      <span className="form-drag-handle">
                        <i className="fas fa-arrows-alt" />
                      </span>
                    </div>
                  )}
                  {this.state.editIndex == index && (
                    <Popup
                      width="500"
                      header="Radio Button Settings"
                      //  parentID="formManage"
                      // save={this.pushBlockToCanvas}
                      // btnLabel="Select"
                      closePopup={() => {
                        if (!item.label) {
                          message.error('Please ensure both Add Label fro Radio Group filled.');
                          return;
                        }
                        this.setState({ editIndex: null });
                      }}
                      close={() => {
                        if (!item.label) {
                          message.error('Please ensure both Add Label fro Radio Group filled.');

                          return;
                        }
                        this.setState({ editIndex: null });
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          padding: "25px",
                        }}
                      >
                        <div>
                          <div>
                            Add label <sup>*</sup>
                          </div>

                          <input
                            className="form-control"
                            value={item.label}
                            required={true}
                            onChange={(e) => {
                              this.inputLabelChange(e, index, this.props.ID);
                            }}
                            type="text"
                          />
                          <div className="col-sm-12 required" style={{ padding: "0 0 10px 0" }}>
                            <div>Show label</div>
                            <div className="radiusToggle">
                              <input
                                key={Math.random()}
                                onChange={(e) => {
                                  this.showRadioButtonGroupLabel(e, index, this.props.ID);
                                }}
                                type="checkbox"
                                id="autoplay"
                                checked={item.show_label && "checked"}
                              />
                            </div>
                          </div>
                        </div>
                        <div>
                          <div>Radio Button Label <sup>*</sup></div>
                          <div
                            style={{ display: "flex", flexDirection: "row" }}
                            className="addOptions"
                          >
                            <input
                              className="form-control"
                              value={this.state.radioLabel}
                              placeholder=""
                              onChange={(e) => {
                                this.newRadioLabel(e, index);
                              }}
                              type="text"
                            // disabled={this.state.radioLabel == ""}
                            />
                            <i
                              onClick={this.state.radioLabel && item.label ? () => this.pushRadioButton(index) : null}
                              className="fas fa-plus-circle"
                              style={{
                                cursor: this.state.radioLabel && item.label ? 'pointer' : 'not-allowed',
                                opacity: this.state.radioLabel && item.label ? 1 : 0.5,
                              }}
                            ></i>
                            <div>{item.placeholder}</div>
                          </div>
                        </div>
                        <div className="col-sm-12 required" style={{ padding: "0px" }}>
                          <div>Required</div>
                          <div className="radiusToggle">
                            <input
                              key={Math.random()}
                              onChange={(event) => {
                                this.requiredChange(
                                  event,
                                  index,
                                  this.props.ID
                                );
                              }}
                              type="checkbox"
                              id="autoplay"
                              checked={item.required && "checked"}
                            />
                          </div>
                        </div>
                        <div className="optionsList">
                          <ul className="radioLabelGroup">
                            <Container
                              //  onDragStart={()=>{
                              //   setTimeout(function(){debugger }, 2000);
                              // }}
                              onDrop={(e) => {
                                this.sortingRadio(e, index);
                              }}
                            >
                              {item.radioFields.map((item, indexLabel) => {
                                return (
                                  <Draggable key={indexLabel}>
                                    <li>
                                      {item.label}
                                      <img
                                        key={indexLabel}
                                        onClick={() => {
                                          this.deleteRadioButton(
                                            index,
                                            indexLabel
                                          );
                                        }}
                                        src={DeleteOption}
                                      />
                                    </li>
                                  </Draggable>
                                );
                              })}
                            </Container>
                          </ul>
                        </div>
                      </div>
                    </Popup>
                  )}
                </div>
              </Draggable>
            );
          }
          if (item.type == "checkbox") {
            return (
              <Draggable key={index}>
                <div
                  className={
                    "form-group " + (this.state.editFields ? "editingForm" : "")
                  }
                  key={index}
                >
                  <div
                    className="radio"
                    style={{ display: "flex", flexDirection: "row" }}
                  >
                    <input
                      type={item.type}
                      id={"checkbox" + "-" + this.props.ID + index}
                      name="checkbox"
                    />
                    <div
                      htmlFor={"checkbox" + "-" + this.props.ID + index}
                      className="radio-label"
                    >
                      {item.label} <sup>{item.required ? "*" : ""}</sup>
                    </div>
                  </div>

                  {this.state.editFields && (
                    <div className="action">
                      <span
                        className={
                          "editField " +
                          (this.state.editIndex == index ? "active" : " ")
                        }
                        onClick={() => {
                          this.editThis(index);
                        }}
                      ></span>
                      <span
                        className="deleteField"
                        onClick={() => {
                          this.deleteInput(index, this.props.ID);
                        }}
                      ></span>
                      <span className="form-drag-handle">
                        <i className="fas fa-arrows-alt" />
                      </span>
                    </div>
                  )}
                  {this.state.editIndex == index && (
                    <Popup
                      width="500"
                      header="Checkbox Settings"
                      //  parentID="formManage"
                      // save={this.pushBlockToCanvas}
                      // btnLabel="Select"
                      closePopup={() => {
                        this.setState({ editIndex: null });
                      }}
                      close={() => {
                        this.setState({ editIndex: null });
                      }}
                    >
                      <div style={{ padding: "25px" }}>
                        <div className="col-sm-12">
                          <div>Input Label</div>
                          <input
                            className="form-control"
                            value={item.label}
                            onChange={(e) => {
                              this.inputLabelChange(e, index, this.props.ID);
                            }}
                            type="text"
                          />
                        </div>

                        <div className="col-sm-12 required">
                          <div>Required</div>
                          <div className="radiusToggle">
                            <input
                              key={Math.random()}
                              onChange={(event) => {
                                this.requiredChange(
                                  event,
                                  index,
                                  this.props.ID
                                );
                              }}
                              type="checkbox"
                              id="autoplay"
                              checked={item.required && "checked"}
                            />
                          </div>
                        </div>
                      </div>
                    </Popup>
                  )}
                </div>
              </Draggable>
            );
          }
          if (item.type == "dropdown") {
            return (
              <Draggable key={index}>
                <div
                  className={
                    "form-group " + (this.state.editFields ? "editingForm" : "")
                  }
                  key={index}
                >
                  <div>
                    {item.label} <sup>{item.required ? "*" : ""}</sup>
                  </div>
                  {/* <input
              className="form-control"
              type={item.type}
              placeholder={item.placeholder}
            /> */}
                  <select
                    className="form-control"
                    ref={(el) => {
                      if (formConfig.enabled && el && this.props.selectedFont) {
                        el.style.setProperty("font-family", this.props.selectedFont, "important");
                      }
                    }}
                  >
                    {item.options.length > 0 &&
                      item.options.map((option, index) => {
                        return (
                          <option
                            key={index}
                            value={option}
                            ref={(el) => {
                              if (formConfig.enabled && el && this.props.selectedFont) {
                                el.style.setProperty("font-family", this.props.selectedFont, "important");
                              }
                            }}
                          >
                            {option}
                          </option>
                        );
                      })}
                  </select>
                  {this.state.editFields && (
                    <div className="action">
                      <span
                        className={
                          "editField " +
                          (this.state.editIndex == index ? "active" : " ")
                        }
                        onClick={() => {
                          this.editThis(index);
                        }}
                      ></span>
                      <span
                        className="deleteField"
                        onClick={() => {
                          this.deleteInput(index, this.props.ID);
                        }}
                      ></span>
                      <span className="form-drag-handle">
                        <i className="fas fa-arrows-alt" />
                      </span>
                    </div>
                  )}
                  {this.state.editIndex == index && (
                    <Popup
                      width="500"
                      header="Dropdown Menu Settings"
                      //  parentID="formManage"
                      // save={this.pushBlockToCanvas}
                      // btnLabel="Select"
                      closePopup={() => {
                        this.setState({ editIndex: null });
                      }}
                      close={() => {
                        this.setState({ editIndex: null });
                      }}
                    >
                      <div style={{ padding: "25px" }}>
                        <div className="col-sm-12 addOptions">
                          <div>Add Options</div>

                          <input
                            placeholder="Add option"
                            className="form-control"
                            value={this.state.optionVal}
                            onChange={(e) => {
                              this.setState({ optionVal: e.target.value });
                            }}
                          />
                          <i
                            onClick={() => {
                              this.addOptions(
                                index,
                                this.props.ID,
                                this.state.optionVal
                              );
                            }}
                            className="fas fa-plus-circle"
                          ></i>
                        </div>
                        <ul className="optionsList">
                          <Container
                            onDrop={(e) => {
                              this.sortSelectOptions(e, index);
                            }}
                          >
                            {item.options.map((item, itemIndex) => {
                              return (
                                <Draggable key={itemIndex}>
                                  <li key={itemIndex}>
                                    {item}
                                    <img
                                      key={itemIndex}
                                      onClick={() => {
                                        this.deleteOption(
                                          index,
                                          this.props.ID,
                                          itemIndex
                                        );
                                      }}
                                      src={DeleteOption}
                                    />
                                  </li>
                                </Draggable>
                              );
                            })}
                          </Container>
                        </ul>
                        <div className="col-sm-12">
                          <div>Input Label</div>
                          <input
                            className="form-control"
                            value={item.label}
                            onChange={(e) => {
                              this.inputLabelChange(e, index, this.props.ID);
                            }}
                            type="text"
                          />
                        </div>
                        <div className="col-sm-12 required">
                          <div>Required?</div>
                          <div className="radiusToggle">
                            <input
                              key={Math.random()}
                              onChange={(event) => {
                                this.requiredChange(
                                  event,
                                  index,
                                  this.props.ID
                                );
                              }}
                              type="checkbox"
                              id="autoplay"
                              checked={item.required && "checked"}
                            />
                          </div>
                        </div>
                      </div>
                    </Popup>
                  )}
                </div>
              </Draggable>
            );
          }
        })}
      </Container>
    );

    const submitBtn = (
      <div
        className={
          "form-group submitBtnWrapper " +
          (this.state.editFields ? "editingForm" : "")
        }
      >
        {this.state.formFields.map((item, index) => {
          if (item.type == "submit") {
            return (
              <Fragment key={index}>
                <div className="text-center" key={index}>
                  <div
                    style={{
                      position: "relative",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent:
                        item.style.float == "left"
                          ? "flex-start"
                          : item.style.float == "right"
                            ? "flex-end"
                            : "center",
                      width: "100%",
                    }}
                  >
                    <button
                      type="button"
                      onMouseEnter={this.toggleHover}
                      onMouseLeave={this.toggleHover}
                      disabled={!allRadioGroupsSelected}
                      style={{
                        backgroundColor:
                          this.state.submitBtnHover === true
                            ? typeof item.hoverBtn.btnBg == "string"
                              ? item.hoverBtn.btnBg
                              : `rgba(
                          ${item.hoverBtn.btnBg.r},
                          ${item.hoverBtn.btnBg.g},
                          ${item.hoverBtn.btnBg.b},
                          ${item.hoverBtn.btnBg.a}
                        )`
                            : typeof item.normalBtn.btnBg == "string"
                              ? item.normalBtn.btnBg
                              : `rgba(
                          ${item.normalBtn.btnBg.r},
                          ${item.normalBtn.btnBg.g},
                          ${item.normalBtn.btnBg.b},
                          ${item.normalBtn.btnBg.a}
                        )`,
                        borderColor:
                          this.state.submitBtnHover === true
                            ? typeof item.hoverBtn.btnBorder == "string"
                              ? item.hoverBtn.btnBorder
                              : `rgba(
                      ${item.hoverBtn.btnBorder.r},
                      ${item.hoverBtn.btnBorder.g},
                      ${item.hoverBtn.btnBorder.b},
                      ${item.hoverBtn.btnBorder.a}
                    )`
                            : typeof item.normalBtn.btnBorder == "string"
                              ? item.normalBtn.btnBorder
                              : `rgba(
                      ${item.normalBtn.btnBorder.r},
                      ${item.normalBtn.btnBorder.g},
                      ${item.normalBtn.btnBorder.b},
                      ${item.normalBtn.btnBorder.a}
                    )`,
                        color:
                          this.state.submitBtnHover === true
                            ? typeof item.hoverBtn.txtColor == "string"
                              ? item.hoverBtn.txtColor
                              : `rgba(
                      ${item.hoverBtn.txtColor.r},
                      ${item.hoverBtn.txtColor.g},
                      ${item.hoverBtn.txtColor.b},
                      ${item.hoverBtn.txtColor.a}
                    )`
                            : typeof item.normalBtn.txtColor == "string"
                              ? item.normalBtn.txtColor
                              : `rgba(
                      ${item.normalBtn.txtColor.r},
                      ${item.normalBtn.txtColor.g},
                      ${item.normalBtn.txtColor.b},
                      ${item.normalBtn.txtColor.a}
                    )`,
                        fontFamily: item.style.fontFamily
                          ? item.style.fontFamily
                          : this.props.selectedFont,
                        height: "auto",
                        fontSize: JSON.parse(item.style.fontSize),
                        // float: item.style.float,

                        marginTop: "10px",
                        paddingTop: JSON.parse(item.style.paddingTop),
                        paddingRight: JSON.parse(item.style.paddingRight),
                        paddingBottom: JSON.parse(item.style.paddingBottom),
                        paddingLeft: JSON.parse(item.style.paddingLeft),
                        borderRadius: JSON.parse(item.style.borderRadius),
                        borderStyle: "solid",
                        borderWidth: JSON.parse(item.style.borderWidth),
                      }}
                      className="btn btn-primary-flimp"
                    >
                      {item.label}
                    </button>

                    {this.state.editFields && (
                      <div className="action">
                        <span
                          onClick={() => {
                            this.editThis(index);
                          }}
                          className={
                            "editField " +
                            (this.state.editIndex == index ? "active" : " ")
                          }
                        ></span>
                      </div>
                    )}
                  </div>
                  <div className="clearfix"></div>
                </div>

                {this.state.editIndex == index && (
                  <Popup
                    width="700"
                    header="Submit Button Settings"
                    parentID="submitManage"
                    // save={this.pushBlockToCanvas}
                    // btnLabel="Select"
                    closePopup={() => {
                      this.setState({ editIndex: null });
                    }}
                    close={() => {
                      this.setState({ editIndex: null });
                    }}
                  >
                    <FormFieldsModal>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          flexWrap: "wrap",
                          justifyContent: "space-between",
                        }}
                        className="modalContentWrapper"
                      >
                        <div>Button Label</div>
                        <input
                          className="form-control"
                          value={item.label}
                          onChange={(e) => {
                            this.inputLabelChange(e, index, this.props.ID);
                          }}
                          type="text"
                        />
                      </div>
                      <div
                        style={{ marginTop: "30px", marginBottom: "5px" }}
                        className="padding-section"
                      >
                        <div className="heading">Font and Alignment</div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          flexWrap: "wrap",
                          justifyContent: "space-between",
                        }}
                        className="modalContentWrapper"
                      >
                        <div style={{ width: "30%", height: "fit-content" }}>
                          <div>Select Font</div>
                          <select
                            style={{}}
                            // className="selectFontFamily"
                            type="text"
                            placeholder="Select Font Family"
                            defaultValue={
                              this.props.fontFamily
                                ? this.props.fontFamily
                                : this.props.selectedFont
                            }
                            onChange={(e) => {
                              this.selectButtonFont(e, index);
                            }}
                          >
                            {UTILS.googleFonts.map((font) => (
                              <option key={font.format} value={font.format}>
                                {font.name}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div style={{ width: "30%", height: "fit-content" }}>
                          <div>Select Font Size</div>

                          <input
                            type="number"
                            defaultValue={item.style.fontSize}
                            onChange={(e) => {
                              this.selectButtonFontSize(e, index);
                            }}
                          />
                        </div>

                        <div style={{ width: "30%", height: "fit-content" }}>
                          <div>Button Align</div>

                          <select
                            className="form-control"
                            value={item.style.float}
                            onChange={(e) => {
                              this.buttonAlign(e, index);
                            }}
                          >
                            <option value="left">Left</option>
                            <option value="center">Center</option>
                            <option value="right">Right</option>
                          </select>
                        </div>
                      </div>
                      <div
                        style={{ marginTop: "30px", marginBottom: "5px" }}
                        className="padding-section"
                      >
                        <div className="heading">Padding</div>
                      </div>
                      <div
                        className="modalContentWrapper"
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          marginTop: "20px",
                        }}
                      >
                        <div className="d-block">
                          <div style={{ marginBottom: "-20px" }}>Top Pixel</div>
                          <Counter
                            minusClick={() =>
                              this.counterMinus(
                                item.style.paddingTop,
                                index,
                                "paddingTop"
                              )
                            }
                            valueContent={
                              item.style.paddingTop == "" ||
                                item.style.paddingTop == undefined
                                ? null
                                : item.style.paddingTop
                            }
                            disabled={false}
                            onChange={(e) => {
                              this.counterChange(e, "paddingTop", index);
                            }}
                            plusClick={() =>
                              this.counterPlus(
                                item.style.paddingTop,
                                index,
                                "paddingTop"
                              )
                            }
                          />
                        </div>
                        <div className="d-block">
                          <div style={{ marginBottom: "-20px" }}>
                            Right Pixel
                          </div>
                          <Counter
                            minusClick={() =>
                              this.counterMinus(
                                item.style.paddingRight,
                                index,
                                "paddingRight"
                              )
                            }
                            valueContent={
                              item.style.paddingRight == "" ||
                                item.style.paddingRight == undefined
                                ? null
                                : item.style.paddingRight
                            }
                            disabled={false}
                            onChange={(e) => {
                              this.counterChange(e, "paddingRight", index);
                            }}
                            plusClick={() =>
                              this.counterPlus(
                                item.style.paddingRight,
                                index,
                                "paddingRight"
                              )
                            }
                          />
                        </div>

                        <div className="d-block">
                          <div style={{ marginBottom: "-20px" }}>
                            Bottom Pixel
                          </div>
                          <Counter
                            minusClick={() =>
                              this.counterMinus(
                                item.style.paddingBottom,
                                index,
                                "paddingBottom"
                              )
                            }
                            valueContent={
                              item.style.paddingBottom == "" ||
                                item.style.paddingBottom == undefined
                                ? null
                                : item.style.paddingBottom
                            }
                            disabled={false}
                            onChange={(e) => {
                              this.counterChange(e, "paddingBottom", index);
                            }}
                            plusClick={() =>
                              this.counterPlus(
                                item.style.paddingBottom,
                                index,
                                "paddingBottom"
                              )
                            }
                          />
                        </div>
                        <div className="d-block">
                          <div style={{ marginBottom: "-20px" }}>
                            Left Pixel
                          </div>{" "}
                          <Counter
                            minusClick={() =>
                              this.counterMinus(
                                item.style.paddingLeft,
                                index,
                                "paddingLeft"
                              )
                            }
                            valueContent={
                              item.style.paddingLeft == "" ||
                                item.style.paddingLeft == undefined
                                ? null
                                : item.style.paddingLeft
                            }
                            disabled={false}
                            onChange={(e) => {
                              this.counterChange(e, "paddingLeft", index);
                            }}
                            plusClick={() =>
                              this.counterPlus(
                                item.style.paddingLeft,
                                index,
                                "paddingLeft"
                              )
                            }
                          />
                        </div>
                      </div>
                      <div
                        style={{ marginTop: "30px", marginBottom: "5px" }}
                        className="padding-section"
                      >
                        <div className="heading">Border</div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          marginTop: "20px",
                          width: "50%",
                          paddingLeft: "25px",
                        }}
                      >
                        <div className="d-block">
                          <div style={{ marginBottom: "-20px" }}>
                            Border Width
                          </div>
                          <Counter
                            minusClick={() =>
                              this.counterMinus(
                                item.style.borderWidth,
                                index,
                                "borderWidth"
                              )
                            }
                            valueContent={
                              item.style.borderWidth == "" ||
                                item.style.borderWidth == undefined
                                ? null
                                : item.style.borderWidth
                            }
                            disabled={false}
                            onChange={(e) => {
                              this.counterChange(e, "borderWidth", index);
                            }}
                            plusClick={() =>
                              this.counterPlus(
                                item.style.borderWidth,
                                index,
                                "borderWidth"
                              )
                            }
                          />
                        </div>
                        <div className="d-block">
                          <div style={{ marginBottom: "-20px" }}>
                            Border Radius
                          </div>{" "}
                          <Counter
                            minusClick={() =>
                              this.counterMinus(
                                item.style.borderRadius,
                                index,
                                "borderRadius"
                              )
                            }
                            valueContent={
                              item.style.borderRadius == "" ||
                                item.style.borderRadius == undefined
                                ? null
                                : item.style.borderRadius
                            }
                            disabled={false}
                            onChange={(e) => {
                              this.counterChange(e, "borderRadius", index);
                            }}
                            plusClick={() =>
                              this.counterPlus(
                                item.style.borderRadius,
                                index,
                                "borderRadius"
                              )
                            }
                          />
                        </div>
                      </div>
                      <hr className="deviderLine" />
                      <div
                        style={{ marginTop: "30px", marginBottom: "5px" }}
                        className="padding-section"
                      >
                        <div className="heading">Normal Color</div>
                      </div>{" "}
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          flexWrap: "wrap",
                        }}
                        className="modalContentWrapper"
                      >
                        <div style={{ width: "300px" }}>
                          <ColorPicker
                            btnLabel="Text Color"
                            colorValue={item.normalBtn.txtColor}
                            colorDefaultValue={{ r: 252, g: 252, b: 252, a: 1 }}
                            getColor={(e) => {
                              this.changeColor(
                                e,
                                "normalBtn",
                                "txtColor",
                                index
                              );
                            }}
                          />
                        </div>
                        <div style={{ width: "300px", marginLeft: "20px" }}>
                          <ColorPicker
                            btnLabel="Background Color"
                            colorValue={item.normalBtn.btnBg}
                            colorDefaultValue={{ r: 12, g: 50, b: 84, a: 1 }}
                            getColor={(e) => {
                              this.changeColor(e, "normalBtn", "btnBg", index);
                            }}
                          />
                        </div>
                        <div style={{ width: "300px" }}>
                          <ColorPicker
                            btnLabel="Border Color"
                            colorValue={item.normalBtn.btnBorder}
                            colorDefaultValue={{ r: 12, g: 50, b: 84, a: 1 }}
                            getColor={(e) => {
                              this.changeColor(
                                e,
                                "normalBtn",
                                "btnBorder",
                                index
                              );
                            }}
                          />
                        </div>
                      </div>
                      <div
                        style={{ marginTop: "30px", marginBottom: "5px" }}
                        className="padding-section"
                      >
                        <div className="heading">Hover Color</div>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          flexWrap: "wrap",
                        }}
                        className="modalContentWrapper"
                      >
                        <div style={{ width: "300px" }}>
                          <ColorPicker
                            btnLabel="Text Color"
                            colorValue={item.hoverBtn.txtColor}
                            colorDefaultValue={{ r: 252, g: 252, b: 252, a: 1 }}
                            getColor={(e) => {
                              this.changeColor(
                                e,
                                "hoverBtn",
                                "txtColor",
                                index
                              );
                            }}
                          />
                        </div>
                        <div style={{ width: "300px", marginLeft: "20px" }}>
                          <ColorPicker
                            btnLabel="Background Color"
                            colorValue={item.hoverBtn.btnBg}
                            colorDefaultValue={{ r: 38, g: 169, b: 225, a: 1 }}
                            getColor={(e) => {
                              this.changeColor(e, "hoverBtn", "btnBg", index);
                            }}
                          />
                        </div>
                        <div style={{ width: "300px" }}>
                          <ColorPicker
                            btnLabel="Border Color"
                            colorValue={item.hoverBtn.btnBorder}
                            colorDefaultValue={{ r: 38, g: 169, b: 225, a: 1 }}
                            getColor={(e) => {
                              this.changeColor(
                                e,
                                "hoverBtn",
                                "btnBorder",
                                index
                              );
                            }}
                          />
                        </div>
                      </div>
                    </FormFieldsModal>
                  </Popup>
                )}
              </Fragment>
            );
          }
        })}
      </div>
    );
    return (
      <div className="form-wrapper">
        <div className="actionControl">
          <span
            onClick={() => this.setState({ manage: true })}
            className={
              "text-setting row-setting" + (this.state.manage ? "active" : "")
            }
          >
            Form Settings
          </span>

          <span
            onClick={this.editFields}
            className={
              "text-setting row-setting" +
              (this.state.editFields ? "active" : " ")
            }
          >
            Edit
          </span>

          <button
            type="button"
            onClick={() => {
              this.props.cloneElement(this.props.element.id);
            }}
            className="clone-item"
          >
            <img src={this.props.CloneICON} />
          </button>
          <span
            className="delete-item"
            onClick={() => {
              this.props.deleteElement(this.props.element.id);
            }}
            href="#"
          >
            <i className="far fa-trash-alt" />
          </span>
        </div>
        {this.state.manage && (
          <Popup
            width="700"
            header=" Manage Form"
            parentID="formManage"
            // save={this.pushBlockToCanvas}
            // btnLabel="Select"
            closePopup={() => {
              this.setState(
                {
                  ...this.state,
                  identifierError: UTILS.validateFormId(this.state.identifier),
                  manage:
                    UTILS.validateFormId(this.state.identifier) == "validId"
                      ? false
                      : true,
                },
                () => {
                  this.dismissErrorAlert();
                }
              );
            }}
            close={() => {
              this.setState(
                {
                  ...this.state,
                  identifierError: UTILS.validateFormId(this.state.identifier),
                  manage:
                    UTILS.validateFormId(this.state.identifier) == "validId"
                      ? false
                      : true,
                },
                () => {
                  this.dismissErrorAlert();
                }
              );
            }}
          >
            <div className="modalScrollContainerSecondary">
              <div className="modalContentWrapper">
                <div>
                  Form Label <small> (For Meta Data and Aria Labels)</small>
                </div>
                <input
                  onChange={this.addFormLabel}
                  defaultValue={this.props.label}
                  placeholder="Add button label"
                  className="textLabelInput"
                  type="text"
                />
                <p
                  style={{ color: "black" }}
                  className="exclude-from-override-style"
                >
                  Enter the Email address to receive form entries.
                </p>
                <div className="formIdWrapper">
                  <input
                    onBlur={this.formEmailAddress}
                    onKeyDown={this.handleKeyDown}
                    onChange={(e) => {
                      this.setState({
                        emailList: e.target.value,
                      });
                    }}
                    value={this.state.emailList}
                    placeholder="Email ID"
                    type="text"
                  />
                </div>
                <div className="emailListWrapper">
                  {(this.props.email != undefined) &
                    (this.props.email != null) &
                    (this.props.email != "")
                    ? this.props.email.split(",").map((step, index) => (
                      <span key={index} className="emailItem">
                        {step}
                        <img
                          onClick={() => {
                            this.deleteEmail(step);
                          }}
                          style={{ height: "7px", marginLeft: "3px" }}
                          src={DeleteEmail}
                        />
                      </span>
                    ))
                    : ""}
                </div>
                {this.state.emailError == "invalidEmail" &&
                  this.state.emailList != "" ? (
                  <Alert
                    color="danger"
                    className="flimpalert"
                    fade={true}
                    style={{ textAlign: "center" }}
                  // toggle={onDismissDelete}
                  >
                    Please enter a valid email address (e.g example@flimp.net)
                  </Alert>
                ) : this.state.emailError == "alreadyExists" ? (
                  <Alert
                    color="danger"
                    className="flimpalert"
                    fade={true}
                    style={{ textAlign: "center" }}
                  // toggle={onDismissDelete}
                  >
                    <p>Email already exists</p>
                  </Alert>
                ) : (
                  ""
                )}
                <p style={{ color: "black", marginTop: "15px" }}>
                  Enter a Form Identifier
                </p>
                <small style={{ fontSize: "10px", display: "block" }}>
                  <small style={{ color: "red" }}>*</small> Cannot exceed
                  <strong> 31 </strong>
                  characters
                </small>

                <small style={{ fontSize: "10px", display: "block" }}>
                  <small style={{ color: "red" }}>*</small> Cannot contain
                  characters: <strong> \ / : ? * [ ]</strong>
                </small>
                <div className="formIdWrapper">
                  {" "}
                  {this.state.identifier != "" ? (
                    <span className="formItem">
                      {this.state.identifier}
                      <img
                        onClick={this.deleteIdentifier}
                        style={{ height: "7px", marginLeft: "3px" }}
                        src={DeleteEmail}
                      />
                    </span>
                  ) : (
                    <input
                      onBlur={this.saveIdentifier}
                      onKeyDown={this.handleKeyDownIdentifier}
                      placeholder="Form ID"
                      type="text"
                      required={true}
                    />
                  )}
                </div>
                <div className="clearfix"></div>
                {this.state.identifierError == "tooShort" ? (
                  <Alert
                    color="danger"
                    className="flimpalert"
                    fade={true}
                    style={{ textAlign: "center" }}
                  // toggle={onDismissDelete}
                  >
                    <p>Form ID cannot be empty, please provide a value.</p>
                  </Alert>
                ) : this.state.identifierError == "tooLong" ? (
                  <Alert
                    color="danger"
                    className="flimpalert"
                    fade={true}
                    style={{ textAlign: "center" }}
                  // toggle={onDismissDelete}
                  >
                    <p>Form ID cannot exceed 31 characters</p>
                  </Alert>
                ) : this.state.identifierError == "invalidChars" ? (
                  <Alert
                    color="danger"
                    className="alert"
                    fade={true}
                    style={{ textAlign: "center" }}
                  // toggle={onDismissDelete}
                  >
                    <p>Form ID cannot contain values: \ / ? * [ ]</p>
                  </Alert>
                ) : (
                  ""
                )}
                <div
                  style={{
                    display: "flex",
                    gap: "6px",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div style={{ display: "flex", gap: "6px" }}>
                    <input
                      key={Math.random()}
                      className="checkMark"
                      type="checkbox"
                      checked={this.props.FormObj.sendConfirmation || false}
                      onChange={this.handleSendConfirmationEmails}
                    />
                    <div>Send confirmation emails</div>
                  </div>

                  <button
                    style={{ marginTop: "20px" }}
                    onClick={() =>
                      this.setState({ addFields: !this.state.addFields })
                    }
                    className="select-various-content-button"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                    >
                      <g id="menu" transform="translate(-6 -1.999)">
                        <g
                          id="Path_350"
                          data-name="Path 350"
                          transform="translate(6 2)"
                          fill="rgba(255,255,255,0)"
                        >
                          <path
                            d="M 15 15 L 1 15 L 1 1 L 15 1 L 15 15 Z"
                            stroke="none"
                          />
                          <path
                            d="M 2 2 L 2 14 L 14 14 L 14 2 L 2 2 M 0 0 L 16 0 L 16 16 L 0 16 L 0 0 Z"
                            stroke="none"
                            fill="#0c3254"
                          />
                        </g>
                        <line
                          id="Line_51"
                          data-name="Line 51"
                          x2="7.5"
                          transform="translate(10 7)"
                          fill="none"
                          stroke="#0c3254"
                          strokeLinecap="square"
                          strokeWidth="1.8"
                        />
                        <line
                          id="Line_55"
                          data-name="Line 55"
                          x2="7.5"
                          transform="translate(10 10)"
                          fill="none"
                          stroke="#0c3254"
                          strokeLinecap="square"
                          strokeWidth="1.8"
                        />
                        <line
                          id="Line_56"
                          data-name="Line 56"
                          x2="2.5"
                          transform="translate(10 13)"
                          fill="none"
                          stroke="#0c3254"
                          strokeLinecap="square"
                          strokeWidth="1.8"
                        />
                      </g>
                    </svg>
                    Add Field
                  </button>
                </div>
              </div>

              <div style={{ marginTop: "10px" }} className="row">
                {this.state.addFields && (
                  <div className="addFieldWrapper">
                    <div
                      onClick={() => this.setState({ addFields: false })}
                      className="overlayField"
                    ></div>
                    <ul className="addField">
                      <li
                        onClick={() => {
                          this.addNewField(this.props.ID, {
                            data: "heading",
                            type: "heading",
                            content: "Form heading here",
                          });
                        }}
                      >
                        <img src={Heading} />
                        Form heading
                      </li>
                      <li
                        onClick={() => {
                          this.addNewField(this.props.ID, {
                            data: "subheading",
                            type: "subheading",
                            content: "Form sub heading here",
                          });
                        }}
                      >
                        <img src={SubHeading} />
                        Form sub heading
                      </li>
                      <li
                        onClick={() => {
                          this.addNewField(this.props.ID, {
                            data: "input",
                            type: "text",
                            placeholder: "Enter name",
                            label: "Add label",
                            required: false,
                          });
                        }}
                      >
                        <img src={InputFields} />
                        Input text
                      </li>
                      <li
                        onClick={() => {
                          this.addNewField(this.props.ID, {
                            data: "textarea",
                            type: "textarea",
                            placeholder: "Add text",
                            label: "Add label",
                            required: false,
                          });
                        }}
                      >
                        <img src={Textarea} />
                        Text Area
                      </li>
                      <li
                        onClick={() => {
                          this.addNewField(this.props.ID, {
                            data: "dropdown",
                            type: "dropdown",
                            placeholder: "Add text",
                            label: "Add label",
                            options: [],
                            required: false,
                          });
                        }}
                      >
                        <img src={Dropdown} />
                        Dropdown
                      </li>
                      <li
                        onClick={() => {
                          this.addNewField(this.props.ID, {
                            data: "radioGroup",
                            type: "radioGroup",
                            label: "Add Radio Buttons Label",
                            show_label: true,
                            required: true,
                            radioFields: [],
                          });
                        }}
                      >
                        <img src={Radio} />
                        Radio Group
                      </li>
                      <li
                        onClick={() => {
                          this.addNewField(this.props.ID, {
                            data: "checkbox",
                            type: "checkbox",
                            label: "Add label",
                            required: false,
                          });
                        }}
                      >
                        <img src={Checkbox} />
                        Checkbox
                      </li>
                    </ul>
                  </div>
                )}
              </div>
              <div
                style={{ marginTop: "30px", marginBottom: "5px" }}
                className="padding-section"
              >
                <div className="heading">Width</div>
              </div>
              <div
                className="modalContentWrapper"
                style={{ display: "flex", flexDirection: "row", width: "100%" }}
              >
                <div
                  className="col-sm-2 formWidthPercentage"
                  style={{ marginRight: "30px" }}
                >
                  <div>Full Width</div>
                  <input
                    key={Math.random()}
                    className="checkMark"
                    type="checkbox"
                    id="widthPercentage"
                    name="width"
                    value="percentage"
                    onChange={(e) => {
                      this.widthToggle(e, "width");
                    }}
                    checked={this.props.width == "0" ? true : false}
                  />
                  <div htmlFor="widthPercentage"></div>
                </div>
                {this.props.width !== "0" && (
                  <div>
                    <Counter
                      label="Width"
                      minusClick={() =>
                        this.formCounterMinus(
                          this.props.width,
                          this.props.ID,
                          "width"
                        )
                      }
                      valueContent={
                        this.props.width == "" || this.props.width == undefined
                          ? null
                          : this.props.width
                      }
                      disabled={false}
                      onChange={(e) => {
                        this.formCounterChange(e, this.props.ID, "width");
                      }}
                      plusClick={() =>
                        this.formCounterPlus(
                          this.props.width,
                          this.props.ID,
                          "width"
                        )
                      }
                    />
                    <div className="clear"></div>
                    <small className="instruction">
                      {" "}
                      {this.props.width == "" || this.props.width == undefined
                        ? "Enter width manually in numbers."
                        : null}
                    </small>
                  </div>
                )}
              </div>
              <div
                style={{ marginTop: "30px", marginBottom: "20px" }}
                className="padding-section"
              >
                <div className="heading">Border</div>
              </div>

              <div
                className="modalContentWrapper"
                style={{
                  marginTop: "10px",
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                }}
              >
                <div className="col-sm-3">
                  <Counter
                    label="Border"
                    minusClick={() =>
                      this.formCounterMinus(
                        this.props.borderWidth,
                        this.props.ID,
                        "borderWidth"
                      )
                    }
                    valueContent={
                      this.props.borderWidth == "" ||
                        this.props.borderWidth == undefined
                        ? null
                        : this.props.borderWidth
                    }
                    disabled={false}
                    onChange={(e) => {
                      this.formCounterChange(e, this.props.ID, "borderWidth");
                    }}
                    plusClick={() =>
                      this.formCounterPlus(
                        this.props.borderWidth,
                        this.props.ID,
                        "borderWidth"
                      )
                    }
                  />
                </div>
                <div className="col-sm-4">
                  <Counter
                    label="Border Radius"
                    minusClick={() =>
                      this.formCounterMinus(
                        this.props.borderRadius,
                        this.props.ID,
                        "borderRadius"
                      )
                    }
                    valueContent={
                      this.props.borderRadius == "" ||
                        this.props.borderRadius == undefined
                        ? null
                        : this.props.borderRadius
                    }
                    disabled={false}
                    onChange={(e) => {
                      this.formCounterChange(e, this.props.ID, "borderRadius");
                    }}
                    plusClick={() =>
                      this.formCounterPlus(
                        this.props.borderRadius,
                        this.props.ID,
                        "borderRadius"
                      )
                    }
                  />
                </div>
                <div></div>
                <div style={{ marginTop: "24px" }} className="col-sm-6">
                  <ColorPicker
                    btnLabel="Border Color"
                    colorValue={this.props.borderColor}
                    colorDefaultValue={{ r: 252, g: 252, b: 252, a: 1 }}
                    getColor={(e) => {
                      this.changeFormColor(e, this.props.ID, "borderColor");
                    }}
                  />
                </div>
              </div>

              <div
                style={{ marginTop: "30px", marginBottom: "5px" }}
                className="padding-section"
              >
                <div className="heading">Margin</div>
              </div>

              <div
                className="modalContentWrapper"
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                <UnitSelector
                  value={
                    this.props.formMarginUnit ? this.props.formMarginUnit : "px"
                  }
                  onChange={(e) => {
                    this.unitValueChange(e, "formMarginUnit");
                  }}
                />
              </div>

              <div
                style={{ display: "flex", flexDirection: "row" }}
                className="modalContentWrapper"
              >
                <div className="col-sm-3">
                  <Counter
                    label="Top"
                    small={
                      this.props.formMarginUnit === "%" ? "percent" : "pixel"
                    }
                    minusClick={() =>
                      this.formCounterMinus(
                        this.props.marginTop,
                        this.props.ID,
                        "marginTop"
                      )
                    }
                    valueContent={this.props.marginTop}
                    disabled={false}
                    onChange={(e) => {
                      this.formCounterChange(e, this.props.ID, "marginTop");
                    }}
                    plusClick={() =>
                      this.formCounterPlus(
                        this.props.marginTop,
                        this.props.ID,
                        "marginTop"
                      )
                    }
                  />
                </div>
                <div className="col-sm-3">
                  <Counter
                    label="Bottom"
                    small={
                      this.props.formMarginUnit === "%" ? "percent" : "pixel"
                    }
                    minusClick={() =>
                      this.formCounterMinus(
                        this.props.marginBottom,
                        this.props.ID,
                        "marginBottom"
                      )
                    }
                    valueContent={this.props.marginBottom}
                    disabled={false}
                    onChange={(e) => {
                      this.formCounterChange(e, this.props.ID, "marginBottom");
                    }}
                    plusClick={() =>
                      this.formCounterPlus(
                        this.props.marginBottom,
                        this.props.ID,
                        "marginBottom"
                      )
                    }
                  />
                </div>
              </div>

              <div
                style={{ marginTop: "10px", marginBottom: "20px" }}
                className="padding-section"
              >
                <div className="heading">Color</div>
              </div>
              <div
                className="modalContentWrapper"
                style={{ display: "flex", flexDirection: "row" }}
              >
                <div className="col-sm-6">
                  <ColorPicker
                    btnLabel="Label Color"
                    colorValue={this.props.color}
                    colorDefaultValue={{ r: 51, g: 51, b: 51, a: 1 }}
                    getColor={(e) => {
                      this.changeFormColor(e, this.props.ID, "color");
                    }}
                  />
                </div>
                <div className="col-sm-6">
                  <ColorPicker
                    btnLabel="Background Color"
                    colorValue={this.props.backgroundColor}
                    colorDefaultValue={{ r: 252, g: 252, b: 252, a: 1 }}
                    getColor={(e) => {
                      this.changeFormColor(e, this.props.ID, "backgroundColor");
                    }}
                  />
                </div>
              </div>
            </div>
          </Popup>
        )}

        <div
          className={
            "formWrapper formElementWrapper" +
            (this.props.formArray.length == 2 ? " emailFieldWrapper" : " ")
          }
        >
          <form
            style={{
              fontFamily: this.props.fontFamily
                ? this.props.fontFamily
                : this.props.selectedFont,
              maxWidth:
                this.props.width == "" || this.props.width == "0"
                  ? "100%"
                  : this.props.width + "px",
              width: "100%",
              display: "flex",
              flexDirection: "column",
              borderStyle: this.props.borderStyle,
              borderWidth: JSON.parse(this.props.borderWidth),
              borderRadius: JSON.parse(this.props.borderRadius),
              borderColor:
                typeof this.props.borderColor == "string"
                  ? this.props.borderColor
                  : `rgba(
                ${this.props.borderColor.r},
                ${this.props.borderColor.g},
                ${this.props.borderColor.b},
                ${this.props.borderColor.a}
              )`,
              backgroundColor:
                typeof this.props.backgroundColor == "string"
                  ? this.props.backgroundColor
                  : `rgba(
                    ${this.props.backgroundColor.r},
                    ${this.props.backgroundColor.g},
                    ${this.props.backgroundColor.b},
                    ${this.props.backgroundColor.a}
                  )`,
              color:
                typeof this.props.color == "string"
                  ? this.props.color
                  : `rgba(
                    ${this.props.color.r},
                    ${this.props.color.g},
                    ${this.props.color.b},
                    ${this.props.color.a}
                  )`,
              marginTop:
                this.props.marginTop +
                (this.props.formMarginUnit ? this.props.formMarginUnit : "px"),
              marginRight:
                this.props.marginRight +
                (this.props.formMarginUnit ? this.props.formMarginUnit : "px"),
              marginBottom:
                this.props.marginBottom +
                (this.props.formMarginUnit ? this.props.formMarginUnit : "px"),
              marginLeft:
                this.props.marginLeft +
                (this.props.formMarginUnit ? this.props.formMarginUnit : "px"),
            }}
            className={
              "formMain " +
              (this.props.formArray.length == 2 ? "emailField" : " ")
            }
          >
            {" "}
            {formFields}
            {submitBtn}
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    layout: state.present.layout,
    preset: state.present.preset,
    layoutTitle: state.present.layoutTitle,
    selectedFont: state.present.selectedFont,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Form);
